import { ExamEventExamineeStatus, ExamEventStatus, CancelationReason } from '@exam-center/graphql';
export const EXAM_EVENT_EXAMINEE_OVERRIDABLE_EMAIL_STATUSES = [
  ExamEventExamineeStatus.PrepareForExam,
];

export const EXAM_EVENT_EXAMINEE_CANCELLABLE_STATUSES = [
  ExamEventExamineeStatus.Registered,
  ExamEventExamineeStatus.PrepareForExam,
  ExamEventExamineeStatus.InProgress,
];

export const EXAM_EVENT_EXAMINEE_REINSTATABLE_STATUSES = [ExamEventExamineeStatus.Canceled];

export const EXAM_EVENT_ACTIONABLE_STATUSES = [
  ExamEventStatus.Scheduled,
  ExamEventStatus.ReadyToExam,
  ExamEventStatus.InProgress,
];

export const CANCELATION_REASON_CATEGORIES = [
  { value: CancelationReason.Cheating, label: 'พบการทุจริต' },
  { value: CancelationReason.TechnicalIssue, label: 'เหตุขัดข้องทางเทคนิค' },
  { value: CancelationReason.Accident, label: 'เหตุสุดวิสัย' },
] as const;
